import { DocumentTaxonomyMainCategories } from "@common/documentCategories";
import { GradientColors } from "@helpers/segment";

export const documentStatusGradientColors: Record<
    DocumentTaxonomyMainCategories,
    GradientColors
> = {
    tax: {
        start: "#FCBDBD",
        subtitle: "#0f182680",
    },
    receipts: {
        start: "#B3E3FF",
        subtitle: "#0f182680",
    },
    account_statements: {
        start: "#C1F1D8",
        subtitle: "#0f182680",
    },
    loan_statements: {
        start: "#FFC4BE",
        subtitle: "#0f182680",
    },
    lease_statements: {
        start: "#E1C5FF",
        subtitle: "#0f182680",
    },
    formation_documents: {
        start: "#FFE9BE",
        subtitle: "#0f182680",
    },
    legal_documents: {
        start: "#D1D3F1",
        subtitle: "#0f182680",
    },
    accounts_receivable_payable: {
        start: "#FFBBCD",
        subtitle: "#0f182680",
    },
    financial_statements: {
        start: "#BEF2F1",
        subtitle: "#0f182680",
    },
    payroll: {
        start: "#E4F1BD",
        subtitle: "#0f182680",
    },
    checks: {
        start: "#D1DEF4",
        subtitle: "#0f182680",
    },
    assets: {
        start: "#CDF4C0",
        subtitle: "#0f182680",
    },
    transaction_records: {
        start: "#EBBEF3",
        subtitle: "#0f182680",
    },
    other: {
        start: "#E5E5E5",
        subtitle: "#0f182680",
    },
};
